export const ITR_setItrPasswordReducer = {
  ITR_setItrPassword: (state, action) => {
    state.itrPassword = action.payload;
  },
};
